import React, { memo } from "react"
import PropTypes from "prop-types"
import Spinner from "components/common/Spinner"

import { useSelector } from "react-redux"
import { firstLoadingSelector } from "./selectors"
import { Flex } from "antd"

FirstLoading.propTypes = {
  loading: PropTypes.bool,
  name: PropTypes.string,
  new: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
}
function FirstLoading({ loading = false, name = "user", new: newRecord, children, className, ...rest }) {
  const firstLoading = useSelector(firstLoadingSelector(name))

  return !newRecord && (loading || firstLoading) ? (
    <Flex justify="center" align="center" className={className} style={className ? undefined : { height: "55vh" }}>
      <Spinner {...rest} />
    </Flex>
  ) : (
    children
  )
}

export default memo(FirstLoading)
